import { Video } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const SessionFormat = ({ s, line1 }) => (
  <Reveal className="flex flex-col gap-5 rounded-2xl bg-[#22304A] p-8 text-[#FAF8F4] sm:flex-row sm:items-center sm:p-10" data-testid="session-format-box">
    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#B9A9D8]/20">
      <Video className="h-6 w-6 text-[#B9A9D8]" aria-hidden="true" />
    </span>
    <div>
      <p className="font-display text-2xl sm:text-3xl">{line1 || s.format_line1}</p>
      <p className="mt-1 text-[#FAF8F4]/80">{s.format_line2}</p>
    </div>
  </Reveal>
);
